import React, { useState } from 'react';
import { Loader2, RefreshCw, Wifi } from 'lucide-react';
import { toast } from 'sonner';
import { useStudents } from '../contexts/StudentsContext';

/** Honest indicator of whether the Supabase table is answering. */
export function ConnectionStatus() {
  const {
    syncState,
    refresh
  } = useStudents();
  const [retrying, setRetrying] = useState(false);
  const handleRetry = async () => {
    setRetrying(true);
    try {
      await refresh();
      toast.info('Reconnecting to Supabase…');
    } finally {
      setRetrying(false);
    }
  };
  if (syncState === 'offline') {
    return <button type="button" onClick={handleRetry} disabled={retrying} title="Supabase is not answering. Click to retry." className="inline-flex items-center gap-1.5 rounded-xl border border-amber-500/40 bg-amber-500/10 px-2.5 py-1.5 text-xs font-medium text-amber-700 transition-colors hover:bg-amber-500/20 dark:text-amber-300" data-id="element-62" data-mp="1x2k4vqqodepy">
        {retrying ? <Loader2 className="h-3.5 w-3.5 animate-spin" data-id="element-63" data-mp="2ivo0d9jcr6u9" /> : <RefreshCw className="h-3.5 w-3.5" data-id="element-64" data-mp="2iwz459csseld" />}
        <span className="hidden sm:inline" data-id="element-65" data-mp="2mvpqqmjn0du8">{retrying ? 'Retrying…' : 'Disconnected'}</span>
      </button>;
  }
  const connecting = syncState === 'connecting';
  return <span title={connecting ? 'Connecting to Supabase' : 'Connected to Supabase'} className={`glass-flat hidden items-center gap-1.5 rounded-xl px-2.5 py-1.5 text-xs font-medium sm:inline-flex ${connecting ? 'text-muted-foreground' : 'text-emerald-600 dark:text-emerald-400'}`} data-id="element-66" data-mp="2wunomg2ydjpw">
      {connecting ? <Loader2 className="h-3.5 w-3.5 animate-spin" data-id="element-67" data-mp="3an3lez59glid" /> : <Wifi className="h-3.5 w-3.5" data-id="element-68" data-mp="3fkvl4fc5dbx4" />}
      {connecting ? 'Connecting' : 'Live'}
    </span>;
}